import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import PropTypes from "prop-types"
import SiteMenu from "./site-menu"

const HeaderWrapper = styled.header`
  background-color: #202c6a;
`

const SiteInfo = styled.div`
  margin: 0 auto;
  max-width: 960px;
  padding: 2.5rem;
  text-align: center;
`

const SiteTitle = styled.h1`
  margin: 0 0 0.8rem 0;
  font-size: 2.5rem;
  & a {
    color: white;
  }
  & a:hover {
    color: #ffcc06;
  }
`

const SiteDescription = styled.p`
  color: #f2f2f2;
  margin: 0;
  font-size: 0.9rem;
`

const Header = ({ siteTitle, description }) => (
  <HeaderWrapper>
    <SiteInfo>
      <SiteTitle>
        <Link to="/">{siteTitle}</Link>
      </SiteTitle>
      <SiteDescription>{description}</SiteDescription>
    </SiteInfo>
    <SiteMenu />
  </HeaderWrapper>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
  description: PropTypes.string,
  social: PropTypes.array,
}

Header.defaultProps = {
  siteTitle: ``,
  description: ``,
  social: [],
}

export default Header
